import * as d3 from 'd3'
export default {
  
  methods: {

    tbl_System(sysCode) {

      d3.select(`#NO_SYS`).text(this.rawData.find(f=> f.SYS_CODE == sysCode).DESC)
      
      let dataSet = this.sysData.filter(f=> f.SYS_CODE == sysCode)
      let sumTotal = {}

      this.system.cols.filter(f=> f.dps==2).forEach(col=> {
        sumTotal[col.code] = dataSet.map(d => d[col.code]).reduce((a, b) => (a + b))
      })
      sumTotal.SYS_CODE = sysCode

      // start Scroll ---------------------------------------------------------------------------------------
      let viewbox = this.scroll.viewbox
      
      this.canvasContents = this.svg
      .append('g')
      .attr('transform', `translate(${this.system.x}, ${this.system.y+31})`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      this.canvasContents
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', viewbox.width).attr('height', viewbox.height)

      let clippedGroup = this.canvasContents
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

      // clippedGroup // Stroke for temporary
      // .append('rect')
      // .attr('x', 0).attr('y', 0).attr('stroke', '#757575').attr('stroke-width', 0.5)
      // .attr('width', viewbox.width).attr('height', viewbox.height).attr('fill', 'none')
      // end Scroll ---------------------------------------------------------------------------------------

      this.systemCanvas = clippedGroup
      .append('g')
      .attr('id', `CONTENTS_${this.localId}`)
      .attr('transform', `translate(${0}, ${0})`)

      let y_ = 15
      dataSet.forEach((d,i)=> {
        if(i==0) this.current.sys = d.SYS
        this.gmx_Line(this.systemCanvas, 0, this.system.width, y_+5, y_+5, (i==dataSet.length-1) ? '#bcbcbc' : '#E0E0DF', .5, 3)

        let sys = this.systemCanvas
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .call(this.call_System, d)

        sys
        .append('rect')
        .attr('id', `SYS_${d.SYS}`)
        .attr('x', 0).attr('y', -this.system.lineHeight+5)
        .attr('width', this.system.width).attr('height', this.system.lineHeight-2)
        .attr('fill', '#B4E3FA').attr('opacity', this.current.sys == d.SYS ? .3: 0)

        sys
        .append('text')
        .attr('x', this.system.cols[0].tx).attr('y',  0)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', this.system.cols[0].align)
        .text(i+1)

        this.system.cols.forEach((col,c)=> {
          if(c==0) return
          sys
          .append('text')
          .attr('x', col.tx).attr('y',  0)
          .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
          .text(typeof d[col.code] === 'string' && d[col.code].length > 50 ? d[col.code].substr(0,40) + '...' : d[col.code])
          .call(this.event_Link, d , col)
        })

        y_ += this.system.lineHeight
      })

      // TOTAL
      this.systemCanvas
      .append('text')
      .attr('x', this.system.cols[2].ex/2).attr('y',  y_)
      .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', 'middle')
      .text('TOTAL')

      this.system.cols.filter(f=> f.dps==2).forEach(col=> {
        this.systemCanvas
        .append('text')
        .attr('x', col.tx).attr('y',  y_)
        .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
        .text(sumTotal[col.code])
        .call(this.event_Link, sumTotal, col, 'KEY3')
      })

      this.gmx_Line(this.systemCanvas, 0, this.system.width, y_+5, y_+5, '#bcbcbc', .5, 3)

      // Scroll Height
      this.scroll.content.height = y_ + 6
      this.set_ScrollValues()
      

      let first = this.sysData.filter(f=> f.SYS_CODE == sysCode)[0]
      this.tbl_SubSystem(first.SYS, first.SYS_DESC)

    },

  }
}